import getWebShellClientLocale from "../../../../utils/get-webshellclient-locale";
import makeQueryKey from "../../../../utils/make-query-key";
var getCartQueryKey = function getCartQueryKey() {
  var _getWebShellClientLoc = getWebShellClientLocale(),
    country = _getWebShellClientLoc.country;
  return makeQueryKey(['buy/carts/v2', {
    country: country
  }]);
};
export default getCartQueryKey;